import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#00778C",
    },
    secondary: {
      main: "#FFFFFF",
    },
    error: {
      main: "#B00020",
    }
  },
});

export default theme;